import { Form } from 'react-final-form';
import { useTranslation } from '../../../utils/useTranslation';
import { Flex } from '../../layout/Flex';
import { Spin } from '../../layout/Spin/Spin';
import { Typography } from '../../typography/Typography';
import { ErrorMessage } from '../PartnerRegistrationForm/components/ErrorMessage';
import { fieldsMap } from '../PartnerRegistrationForm/constants';
import { PartnerRegistrationFromFields } from '../PartnerRegistrationForm/parts/PartnerRegistrationFromFields';
import { ActionButton, ActionButtonWrapper } from '../PartnerRegistrationForm/styles';
import { PartnerBankDetailsFormProps } from './types';

export const PartnerBankDetails = ({
    onSubmit,
    isLoading,
    errorMessage,
    fieldErrors,
}: PartnerBankDetailsFormProps) => {
    const t = useTranslation();

    return (
        <>
            <Typography variant="title3" weight="medium">
                {t('Счёт для вознаграждения')}
            </Typography>

            <Form
                onSubmit={onSubmit}
                render={({ handleSubmit }) => (
                    <Flex as="form" width="100%" height="100%" onSubmit={handleSubmit}>
                        <PartnerRegistrationFromFields
                            fields={fieldsMap.bankDetails}
                            errors={fieldErrors}
                        />
                        <ActionButtonWrapper>
                            <ActionButton type="submit" size="l" onClick={handleSubmit}>
                                {isLoading ? (
                                    <Spin color="var(--color-invert)" size={20} />
                                ) : (
                                    t('Далее')
                                )}
                            </ActionButton>
                            <ErrorMessage message={errorMessage} />
                        </ActionButtonWrapper>
                    </Flex>
                )}
            />
        </>
    );
};
